<template>
    <!-- 商圈商品詳細資訊頁 -->
    <div class="page">
        <navigation-bar Close/>
        <!--購物車-->
        <AddCart ref="addCart"/>

        <img v-if="cartFlyImage.visible"
             ref="cartFlyImage"
             class="cart-fly-image"
             :src="cartFlyImage.src"
             :style="cartFlyImage.style"
             alt=""
             aria-hidden="true">

        <div class="main" :key="itemUpdateKey">
            <div class="coupon-top mb-3">
                <img ref="productImage" :src="itemData.itemImage">
                <!--todo 手機版用這套-->
                <div class="text-center footer-button">
                    <el-button round @click="onClickAddCart(false)">加入購物車</el-button>
                    <el-button round type="warning" @click="onClickAddCart(true)">直接購買</el-button>
                </div>
            </div>
            <div class="container">
                <div class="coupon-body">
                    <h4 class="mt-2">{{itemData.name}}</h4>
                    <div class="d-flex">
                        <div class="red fee">${{isNaN(itemData.price * buyAmount)? 0: itemData.price * buyAmount}}</div>
                        <NumberController :params="numberControllerParams" @triggerEvent="numberControllerEvent" :size="'mini'"
                                          v-if="!isAdmission"/>
                        <!--todo 電腦版用這套-->
                        <el-button round class="addBtn" type="warning" @click="onClickAddCart(false)" v-if="!isAdmission">加入購物車</el-button>
                    </div>

                    <!--入場憑證用-->
                    <template v-if="isAdmission">
                        <!--入場憑證選擇詳細場次-->
                        <SelectDate v-show="showDate"
                                    :imageSrc="itemData.itemImage"
                                    :dateSetting="ticketDateSetting"
                                    :buyStyle="buyStyle"
                                    :defaultSelectDate="selectDate"
                                    :defaultSelectTime="selectTime"
                                    :defaultBuyAmount="buyAmount"
                                    :price="itemData.price"
                                    @close="closeShowDate"
                                    @selectDateChanged="onDateChanged"
                                    @selectTimeChanged="onSelectTimeChanged"
                                    @onBuyAmountChanged="onBuyAmountChanged"/>

                        <div class="selectDate" @click="openSelectDate(0)">
                            <span>{{showTicketDateString}}</span>
                            <i class="el-icon-arrow-down"/>
                        </div>
                    </template>

                    <!--兌換項目-->
                    <template v-if="isShowExchangeItem()">
                        <div class="gift-pack-detail" >
                            <h6>[{{coupon.couponTypeName}}]{{coupon.name}}<span><b>{{itemData.couponAmount}}</b>張</span></h6>
                            <p><i class="el-icon-time mr-1"/>本券兌換期限:{{coupon.startAt}}至{{coupon.endAt}}</p>
                        </div>
                    </template>
                    <template v-if="isShowGiftPackExchangeItem()">
                        <div class="gift-pack-detail">
                            <div v-for="(item, index) in giftPack.giftPackContentList" :key="index">
                                <h6>[{{item.kindName}}]{{item.name}}<span><b>{{item.amount}}</b>張</span></h6>
                                <p><i class="el-icon-time mr-1"/>本券兌換期限:至{{item.convertTimeText}}止</p>
                            </div>
                        </div>
                    </template>


                    <!--TODO 訂位資訊-->
<!--                    <div v-show="isAdmission">-->
<!--                        <p class="ps2 text-center mt-4">人數或日期無法點選，代表改人數或日期暫時不開放 線上訂位或目前訂位時段已無法預約。</p>-->
<!--                        <TicketBooking :dateSetting="ticketDateSetting"-->
<!--                                       :receiveAdult="adult"-->
<!--                                       :receiveChild="child"-->
<!--                                       :receiveDate="ticketDate"-->
<!--                                       :receiveTime="selectTime"-->
<!--                                       @dateChanged="onDateChanged"-->
<!--                                       @adultChanged="onAdultChanged"-->
<!--                                       @childChanged="onChildChanged"-->
<!--                                       @selectTimeChanged="onSelectTimeChanged"-->
<!--                                       @maxPeopleChanged="onMaxPeopleChanged"-->
<!--                        />-->
<!--                    </div>-->
                    <!--購物車商品說明-->
                    <div class="gift-pack-intro" v-if="isShowItemContent()">
                        {{itemData.content}}
                    </div>
                </div>

                <div v-if="isShowContent()">
                    <!--優惠券活動說明-->
                    <h4>說明</h4>
                    <div class="gift-pack-intro">{{coupon.content}}</div>
                </div>
                <div v-if="isShowGiftPackContent()">
                    <!--禮包活動說明-->
                    <h4>說明</h4>
                    <div class="gift-pack-intro">{{giftPack.content}}</div>
                </div>
                <div v-if="isShowCaution()">
                    <!--優惠券注意事項-->
                    <h4>注意事項</h4>
                    <div v-for="(item, index) in coupon.contentPrecautionsList" :key="index" class="li">
                        <p v-html="`${item}`"></p>
                    </div>
                </div>
                <div v-if="isShowGiftPackCaution()">
                    <!--禮包注意事項-->
                    <h4>注意事項</h4>
                    <div v-for="(item, index) in giftPack.publishMethodList" :key="index" class="li">
                        <p v-html="`${item}`"></p>
                    </div>
                </div>
            </div>

        </div>
        <comm-dialog ref="dialog" :value="commDialogShow" :outerContent="dialogTitle" :isCancel="true"
                     @result="closeCommDialog"
                     @close="(value) => { commDialogShow = value }"/>
    </div>
</template>

<script>
    import NumberController from '../../components/NumberController';
    import AddCart from '../product/components/AddCart.vue';
    import Cart from "@/util/cart";
    import SelectDate from '../product/components/SelectDate';
    import utilDate from "@/util/date";
    import CommDialog from '@/components/CommDialog.vue';


    //商圈資訊頁，網頁連結種類 常數
    export const NO_ERROR = 1;          //
    export const DATE_ERROR = 2;        //
    export const TIME_ERROR = 3;        //


    export default {
        name: 'Product',
        components: {
            NumberController,
            AddCart,
            SelectDate,
            CommDialog,
        },
        data() {
            return {
                typeName: '禮包',
                numberControllerParams: {
                    default: 1,
                    min: 1,
                },
                isOpenCart: false,
                shopAreaId: 0,
                itemId: 0,      //物品ID
                buyAmount: 1,      //數量
                fee: 10,         //單價
                itemData: {},   //商品資訊
                coupon: {},     //優惠券資訊
                giftPack: {},   //禮包資訊
                itemUpdateKey: 0,
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",        //url 傳來的加密參數
                dataObject: {},     //url加密參數解析後的值
                cartList: [],
                cartItemAmount: 0,
                imageSrc:"https://d27jswm5an3efw.cloudfront.net/app/uploads/2019/08/image-url-3.jpg",
                isAdmission: false,         //是否為入場憑證
                //挑選場次詳細
                showDate: false,
                //0點選日期場次 1點選加入購物車 2點選直接購買
                buyStyle: 0,

                //dialog
                commDialogShow: false,      //dialog
                dialogTitle: '',            //dialog文字
                functionAfterDialog: [],    //Notice Dialog關閉後要做的事

                //入場憑證
                ticketDateSetting: [],      //日期區間設定，格式在後續註解裡
                ticketTime: [],             //每天的時段，格式 [{id:1 , 時段起:(hh:MM), 時段結束:(hh:MM),... },....]
                selectDate: '',             //要購買的票券日期
                selectTime: '',             //要購買的票券時段
                adult: 0,
                child: 0,
                showTicketDateString: '',   //顯示票券的日期時間
                cartFlyImage: {
                    visible: false,
                    src: '',
                    style: {},
                },
                cartFlyImageTimer: null,
            }
        },
        mounted () {
            //載入初始資料加入購物車
            if (this.dataToken !== "") {
                this.initForDataToken(this.dataToken);
                this.showTicketDateString = this.getShowSelectDateText();
            }
        },
        beforeDestroy() {
            window.clearTimeout(this.cartFlyImageTimer)
        },
        methods: {
            playAddToCartAnimation() {
                if (window.innerWidth >= 1024) {
                    return
                }

                let productImage = this.$refs.productImage
                let addCart = this.$refs.addCart?.$el?.querySelector('.con')
                if (!productImage || !addCart) {
                    return
                }

                let productImageRect = productImage.getBoundingClientRect()
                let addCartRect = addCart.getBoundingClientRect()
                if (productImageRect.width === 0 || productImageRect.height === 0 || addCartRect.width === 0 || addCartRect.height === 0) {
                    return
                }

                window.clearTimeout(this.cartFlyImageTimer)
                this.cartFlyImage = {
                    visible: true,
                    src: productImage.currentSrc || this.itemData.itemImage,
                    style: {
                        left: `${productImageRect.left}px`,
                        top: `${productImageRect.top}px`,
                        width: `${productImageRect.width}px`,
                        height: `${productImageRect.height}px`,
                        opacity: 1,
                        borderRadius: 0,
                        transition: 'none',
                    },
                }

                this.$nextTick(() => {
                    let cartFlyImage = this.$refs.cartFlyImage
                    if (!cartFlyImage) {
                        return
                    }

                    cartFlyImage.getBoundingClientRect()
                    this.cartFlyImage.style = {
                        left: `${addCartRect.left}px`,
                        top: `${addCartRect.top}px`,
                        width: `${addCartRect.width}px`,
                        height: `${addCartRect.height}px`,
                        opacity: 0,
                        borderRadius: '50%',
                        transition: 'left 700ms cubic-bezier(.22,.61,.36,1), top 700ms cubic-bezier(.22,.61,.36,1), width 700ms cubic-bezier(.22,.61,.36,1), height 700ms cubic-bezier(.22,.61,.36,1), border-radius 700ms ease, opacity 180ms ease 520ms',
                    }

                    this.cartFlyImageTimer = window.setTimeout(() => {
                        this.cartFlyImage.visible = false
                    }, 720)
                })
            },
            /** 取資料 */
            setupData: function() {
                let self = this;
                this.$http.fetch`GetShoppingAreaCartProductInfo${{
                    shopAreaCartId: self.itemId,        //商圈商品 id
                    shopAreaId: self.shopAreaId,
                }}
                ${json => {
                    if (json.status) {
                        if (self.$public.notNull(json.data) && json.data !== '') {

                            self.itemData = json.data;

                            if (self.$public.notNull(self.itemData.coupon)) {
                                self.coupon = self.itemData.coupon;
                            }
                            if (self.$public.notNull(self.itemData.giftPack)) {
                                self.giftPack = self.itemData.giftPack;
                            }

                            //如果有時間陣列，就進行轉換
                            if (self.$public.notNull(json.data?.dateList) && json.data?.dateList.length>0) {
                                self.analysisDate(json.data.dateList);
                                self.isAdmission = true;
                            }

                            self.itemUpdateKey++;
                        }
                    }
                }}}`;
            },

            /** 組合日期和時間 */
            analysisDate: function(data) {
                this.ticketDateSetting = [];
                //ticketDateSetting 格式
                // [
                //     {
                //         "id": 1,                         //ID (前端自訂的)
                //         "startDay": "2024-04-11",
                //         "endDay": "2024-04-11",
                //         "intervalType": 1,               //intervalType：1(小時) 2(分鐘) 3(整日) 4(整個區間)
                //         "detailTime": [                  //各時段的資料，intervalType為1、2時才有這欄位
                //             {
                //                 "intervalUnit": 2,       //該場次有多長， 時間單位看上層intervalType
                //                 "sendAmount": 0,
                //                 "sendMax": 200,
                //                 "setAmount": 0,
                //                 "shoppingSoldCount": 0,
                //                 "stageEndTime": "10:00",         //時段的結束時間
                //                 "stageStartTime": "08:00",       //時段的開始時間
                //                 "startBeforeMinuteValid": 15,
                //                 "parentId": 1                    //上層的 id
                //             }, ...
                //         ]
                //     }, ...
                // ]

                if (this.$public.notNull(data)) {
                    if (data.length>0) {
                        let self = this;

                        data.forEach(function (item, index) {
                            //處理每天的子時段結構，新增一些欄位

                            //過濾不能購買的日期和時段
                            //過濾數量不足的部分
                            let nowDate = new Date();
                            let startDate = new Date(`${item.stageStartAt}T23:59:00`);
                            let isNothingToSale = false;       //已無場次

                            //是否超過日期 ?
                            if (startDate > nowDate) {

                                //整理當天的場次時段 (如果不是整天的券的話)
                                let timeClip = [];
                                if (item.intervalType === 1 || item.intervalType === 2) {
                                    //檢查是否有場次時段資料
                                    if (self.$public.notNull(item?.detailList) && item?.detailList.length > 0) {
                                        item.detailList.forEach(function (item2) {

                                            //是否超過時間 ?
                                            let startDateTime = new Date(`${item.stageStartAt} ${item2.stageStartTime}:00`);
                                            let isOverTime = (startDateTime < nowDate);
                                            //是否售完
                                            let isSoldOut = (item2.setAmount <= item2.shoppingSoldCount);

                                            if (!isSoldOut && !isOverTime) {
                                                item2["parentId"] = index;
                                                //如果有時段資料才製作 label
                                                if (item.intervalType === 1 || item.intervalType === 2) {
                                                    item2["label"] = `${item2.stageStartTime}`;
                                                } else {
                                                    item2["label"] = ``;
                                                }
                                                timeClip.tmz_load_push(item2);
                                            }
                                        });
                                    }

                                    if (timeClip.length === 0) {
                                        //已無場次可賣
                                        isNothingToSale = true;
                                    }
                                }

                                let label = '';
                                if (item.intervalType === 4) {
                                    //區間日期
                                    let stageStartStrObject = utilDate.transDate(item.stageStartAt, "MM/dd");
                                    let stageEndStrObject = utilDate.transDate(item.stageEndAt, "MM/dd");
                                    label = `${stageStartStrObject.dateString} - ${stageEndStrObject.dateString}`;

                                } else {
                                    let dateStrObject = utilDate.transDate(item.stageStartAt, "MM/dd");
                                    //整天，或是當天其他時段
                                    label = `${dateStrObject.dateString} (${dateStrObject.weekDay})`;
                                }

                                //每天的資料結構
                                let dateStruct = {
                                    id: index,
                                    stageStartAt: item.stageStartAt,
                                    stageEndAt: item.stageEndAt,
                                    intervalType: item.intervalType,
                                    label: label,
                                    // sendAmount: item.sendAmount,
                                    // sendMax: item.sendMax,
                                    setAmount: item.setAmount,
                                    shoppingSoldCount: item.shoppingSoldCount,
                                    stageId: item.stageId,
                                    detailTime: timeClip,         //每天可選擇的時段的資料
                                }


                                if (item.intervalType === 3 || item.intervalType === 4) {
                                    //如果是整日或是以天爲區間的，要用最外面的 setAmount和 shoppingSoldCount判斷數量
                                    let isDaySoldOut = (item.setAmount <= item.shoppingSoldCount);
                                    if (!isDaySoldOut) {
                                        self.ticketDateSetting.tmz_load_push(dateStruct);
                                    }
                                } else {
                                    if (!isNothingToSale) {
                                        self.ticketDateSetting.tmz_load_push(dateStruct);
                                    }
                                }
                            }
                        });

                        // console.log(`result : ${JSON.stringify(this.ticketDateSetting)}`);
                    }
                }
            },

            numberControllerEvent(arg) {
                this.addAmount(arg.number);
            },

            /** 數量變動 */
            addAmount: function(buyAmount) {
                this.buyAmount = buyAmount;
                if (this.buyAmount >= 99) {
                    this.buyAmount = 99;
                } else if (this.buyAmount <= 0) {
                    this.buyAmount = 0;
                }
            },

            /** 是否顯示兌換項目 */
            isShowExchangeItem: function() {
                return this.$public.notNull(this.coupon) &&
                    this.$public.notNull(this.coupon.couponTypeName) && this.coupon.couponTypeName !== '' &&
                    this.$public.notNull(this.coupon.name) && this.coupon.name !== '' &&
                    !this.isAdmission ;
            },

            /** 是否顯示禮包兌換項目 */
            isShowGiftPackExchangeItem: function() {
                return this.$public.notNull(this.giftPack) &&
                    this.$public.notNull(this.giftPack.giftPackContentList) &&
                    Object.keys(this.giftPack.giftPackContentList).length > 0 &&
                    !this.isAdmission ;
            },

            /** 是否顯示商品說明 */
            isShowItemContent: function() {
                return this.$public.notNull(this.itemData) &&
                    this.$public.notNull(this.itemData.content) && this.itemData.content !== '';
            },

            /** 是否顯示活動說明 */
            isShowContent: function() {
                return this.$public.notNull(this.coupon) &&
                    this.$public.notNull(this.coupon.content) && this.coupon.content !== '';
            },

            /** 是否顯示注意事項 */
            isShowCaution: function() {
                return this.$public.notNull(this.coupon) &&
                    this.$public.notNull(this.coupon.contentPrecautionsList) &&
                    Object.keys(this.coupon.contentPrecautionsList).length > 0;
            },

            /** 是否顯示禮包說明 */
            isShowGiftPackContent: function() {
                return this.$public.notNull(this.giftPack) &&
                    this.$public.notNull(this.giftPack.content) && this.giftPack.content !== '';
            },

            /** 是否顯示禮包注意事項 */
            isShowGiftPackCaution: function() {
                return this.$public.notNull(this.giftPack) &&
                    this.$public.notNull(this.giftPack.contentPrecautionsList) &&
                    Object.keys(this.giftPack.contentPrecautionsList).length > 0;
            },

            /** 顯示 dialog
             * @callback:字串形態, 關閉dialog後要呼叫的函式名稱
             * */
            showCommDialog: function (title, callback) {
                this.commDialogShow = true;
                this.dialogTitle = title;
                if (callback !== '') {
                    this.functionAfterDialog = [callback];
                } else {
                    this.functionAfterDialog = [''];
                }
            },

            /** dialog 回應，按下確定 value = true, 取消 value = false */
            closeCommDialog: function (value) {
                this.commDialogShow = false;

                if (value) {
                    if (this.functionAfterDialog[0] !== '') {
                        this[this.functionAfterDialog[0]]();
                        //清空 callback
                        this.functionAfterDialog = [''];
                    }
                }
            },

            /** dialog確認後 */
            onDeleteItemConfirm(){
                //移除不同商圈的商品
                Cart.removeItemExceptShopAreaId(this.shopAreaId);
                this.addItemToCart();
            },

            /** 加到購物車, isClickBuy:true 爲直接購買 */
            onClickAddCart(isClickBuy){
                //入場憑證用
                if(this.isAdmission){
                    if (isClickBuy) {
                        this.openSelectDate(2);
                    } else {
                        this.openSelectDate(1);
                    }
                } else {
                    //檢查購物車目前記錄的商圈
                    if (this.checkCart()) {
                        let result = this.addItemToCart();
                        if (result && isClickBuy) {
                            //如果是直接購買，就跳頁
                            this.gotoCartPage(this.itemData.id, this.buyAmount);
                        }
                    }
                }
                return false;
            },

            /** 加到購物車(入場憑證專用), isClickBuy:true 爲直接購買 */
            onClickAddCart_Admission(isClickBuy) {
                //入場憑證用
                if (this.isAdmission) {

                    //如果是入場憑證，檢查是否有選日期和時間
                    let errorCode = this.isTicketTimeError(this.selectDate, this.selectTime);
                    if (errorCode === NO_ERROR) {
                        //檢查購物車目前記錄的商圈
                        if (this.checkCart()) {
                            //加入購物車
                            let result = this.addItemToCart();
                            if (result && isClickBuy) {
                                //如果是直接購買，就跳頁
                                this.gotoCartPage(this.itemData.id, this.buyAmount);
                            }
                        }

                    } else {
                        if ( errorCode === DATE_ERROR) {
                            this.$public.showNotify("請選擇要購買的票券日期", false);
                            this.openSelectDate(0);
                        } else {
                            this.$public.showNotify("請選擇要購買的票券的時段", false);
                            this.openSelectDate(0);
                        }
                    }
                }
            },

            /** 跳頁 到購物車 */
            gotoCartPage: function(itemId, amount) {
                // let dataToken = this.cryptDataToken({"action": "addCart", "itemId": itemId, "name": name, "amount": amount});
                let isLogin = this.$auth.isAdminLogin();
                //有登入就直接到購物車，沒有就先跳到登入
                if (isLogin) {
                    this.$router.push({name: 'Cart'});
                } else {
                    this.$public.setPathAfterLogin(`Cart`, "");
                    this.$router.push({name: 'Login'});
                }
            },

            /** 以日期和時間取得入場憑證時段資訊
             *
             * */
            getTicketInfo(date, time) {
                let result = null;
                let self = this;
                if (this.$public.notNull(this.ticketDateSetting) && this.ticketDateSetting.length>0) {
                    //日期整理排序
                    let BreakException = {};
                    try {
                        this.ticketDateSetting.forEach(function (item1) {
                            if (item1.stageStartAt === date) {
                                if (item1.intervalType === 1 || item1.intervalType === 2) {
                                    //檢查訂位的時段是否跟日期搭得起來
                                    if (time !== '') {
                                        if (self.$public.notNull(item1?.detailTime) && item1?.detailTime.length > 0) {

                                            item1.detailTime.forEach(function (item2) {
                                                if (item2.stageStartTime === time) {
                                                    //整合，組成入場憑證票券需要的資料
                                                    result = {
                                                        stageStartAt: item1.stageStartAt,
                                                        stageEndAt: item1.stageEndAt,
                                                        intervalType: item1.intervalType,
                                                        stageStartTime: item2.stageStartTime,
                                                        stageEndTime: item2.stageEndTime,
                                                        couponListId: item1.couponListId,
                                                        shopAreaCartId: item1.id,
                                                        intervalUnit: item2.intervalUnit,
                                                        stageIdForTime: item2.stageId,
                                                        stageIdForDate: item1.stageId,
                                                        label: self.showTicketDateString,       //給購物車顯示用的，日期時間
                                                    };
                                                    throw BreakException;
                                                }
                                            });

                                        }
                                    } else {
                                        //需要指定時段，但沒有帶時段資訊
                                        throw BreakException;
                                    }
                                } else {
                                    //整合，組成入場憑證票券需要的資料
                                    result = {
                                        stageStartAt: item1.stageStartAt,
                                        stageEndAt: item1.stageEndAt,
                                        intervalType: item1.intervalType,
                                        couponListId: item1.couponListId,
                                        shopAreaCartId: item1.id,
                                        stageIdForTime: 0,
                                        stageIdForDate: item1.stageId,
                                        label: self.showTicketDateString,
                                    };
                                    throw BreakException;
                                }
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }
                return result;
            },

            /** 如果是入場憑證，檢查是否有選日期和時間， 有錯誤: true */
            isTicketTimeError(date, time){
                let dateError = true;
                let timeError = true;

                let self = this;
                if (this.$public.notNull(this.ticketDateSetting) && this.ticketDateSetting.length>0) {

                    //日期整理排序
                    this.ticketDateSetting.forEach(function (item1) {

                        if (item1.stageStartAt === date) {
                            dateError = false;

                            if (item1.intervalType === 1 || item1.intervalType === 2) {
                                //檢查訂位的時段是否跟日期搭得起來
                                if (time !== '') {
                                    if (self.$public.notNull(item1?.detailTime) && item1?.detailTime.length > 0) {
                                        let BreakException = {};
                                        try {
                                            item1.detailTime.forEach(function (item2) {
                                                if (item2.stageStartTime === time) {
                                                    timeError = false;
                                                    throw BreakException;
                                                }
                                            });
                                        } catch (e) {
                                            if (e !== BreakException) throw e;
                                        }
                                    }
                                }
                            } else {
                                timeError = !(time === '') ;
                            }
                        }
                    });
                }

                if (dateError) {
                    return DATE_ERROR;
                } else if (timeError) {
                    return TIME_ERROR;
                } else {
                    return NO_ERROR;
                }
            },

            /** 檢查購物車 */
            checkCart(){
                if (this.buyAmount > 0) {

                    //檢查購物車目前記錄的商圈
                    Cart.setShopAreaId(this.shopAreaId);
                    if (!Cart.isAllShopAreaIdSameInCart(this.shopAreaId)) {
                        //商圈ID與新加入的商品不符，出現警告
                        this.showCommDialog("購物車目前不支援跨商圈結帳，非本商圈的物品將會被移除", "onDeleteItemConfirm");
                        return false;
                    }
                    return true;

                } else {
                    this.$public.showNotify("商品數量必須大於 0", false);
                }
                return false;
            },

            /** 加到購物車 */
            addItemToCart(){

                if (this.buyAmount > 0) {
                    //檢查購物車目前記錄的商圈
                    if (Cart.isAllShopAreaIdSameInCart(this.shopAreaId)) {
                        //所有商品都同一個商圈ID
                        //加入購物車

                        //購買的資訊
                        let buyInfo = Cart.getBuyInfo(this.buyAmount, this.shopAreaId);
                        let ticketInfo = {} ;
                        if (this.isAdmission) {
                            //憑證票券資料
                            ticketInfo = this.getTicketInfo(this.selectDate, this.selectTime);
                            ticketInfo["label"] = this.showTicketDateString;

                            if (this.$public.notNull(ticketInfo)) {
                                Cart.addItemToCart(
                                    Cart.newCartItemFull(this.itemData, buyInfo, ticketInfo)
                                );

                            } else {
                                this.$public.showNotify("票券日期與時段錯誤", false);
                                return false;
                            }

                        } else {
                            //一般商品
                            Cart.addItemToCart(
                                Cart.newCartItemFull(this.itemData, buyInfo, {})
                            );
                        }

                        //更新購物車顯示
                        this.onCartUpdate();
                        this.playAddToCartAnimation();
                        this.$store.commit('openShopAreaCartDetail');

                    } else {
                        this.$public.showNotify("購物車目前有不同商圈的商品", false);
                        return false;
                    }
                } else {
                    this.$public.showNotify("商品數量必須大於 0", false);
                    return false;
                }
                return true;
            },

            /** 更新購物車顯示 */
            onCartUpdate() {
                this.$store.commit('updateShopAreaCart', -1);
            },

            /** 取得選擇的票券的日期時間 */
            getShowSelectDateText: function() {
                if (this.selectDate === '') {
                    return "請選擇日期場次";
                } else {
                    return this.getDateStringFromTicketDateSetting(this.selectDate) + " " +this.selectTime;
                }
            },

            /** 取得要顯示的票券日期時間 */
            getDateStringFromTicketDateSetting: function(selectDate) {
                let result = ""
                if (this.$public.notNull(this.ticketDateSetting) &&
                    this.ticketDateSetting.length>0) {

                    //日期整理排序
                    let BreakException = {};
                    try {
                        this.ticketDateSetting.forEach(function (item1) {
                            if (item1.stageStartAt === selectDate) {
                                result = item1.label;
                                throw BreakException;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }
                return result;
            },

            /** 有使用加密型參數 dataToken時的初始函式 */
            initForDataToken: function(item) {
                try {
                    this.dataObject = this.$crypto.uriComponentToObject(item);

                    if (this.$public.notNull(this.dataObject) &&
                        this.$public.notNull(this.dataObject.itemId) ) {
                        this.itemId = this.dataObject.itemId;
                        this.shopAreaId = this.dataObject.shopAreaId;
                        this.setupData();
                    }

                } catch (e) {
                    this.$router.push({name:'Error'});
                    return false;
                }
            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },

            /** 解析 dataToken */
            decryptDataToken: function(item) {
                return this.$crypto.uriComponentToObject(item);
            },

            /** 點選擇日期場次
             * buyStyle = 0, 點選擇日期場次進來的
             * buyStyle = 1, 直接點加入購物車進來的
             * buyStyle = 2, 直接點直接購買進來的
             */
            openSelectDate(buyStyle = 0){
                this.buyStyle = buyStyle;

                this.showDate = true;
            },

            /** 關閉入場憑證日期選單 panel */
            closeShowDate(action){
                this.showDate = false;
                if (action === "AddCart") {
                    //加入購物車
                    this.onClickAddCart_Admission(false);
                } else if (action === "Buy") {
                    //直接購買
                    this.onClickAddCart_Admission(true);
                }
            },

            //TicketBooking 組件相關
            onDateChanged(data){
                this.selectDate = data;
                this.selectTime = '';
                this.showTicketDateString = this.getShowSelectDateText();
            },
            onMaxPeopleChanged(data){
                // this.maxPeople=data;
            },
            onAdultChanged(data){
                // this.adult=data;
            },
            onChildChanged(data){
                // this.child=data;
            },
            onSelectTimeChanged(data){
                this.selectTime = data;
                this.showTicketDateString = this.getShowSelectDateText();
            },
            onBuyAmountChanged(data){
                this.buyAmount = data;
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/gift.less"/>
<style lang="less" scoped>
    .page{
        .cart-fly-image{
            position: fixed;
            z-index: 200;
            object-fit: cover;
            pointer-events: none;
            will-change: left, top, width, height, opacity, border-radius;
            @media(min-width: 1024px){
                display: none;
            }
        }
        .coupon-body{
            border-bottom: none;
            padding-bottom: 0;
            .gift-pack-detail{
                margin: 20px 0;
                p{
                    margin-bottom: 10px;
                }
            }
            .gift-pack-intro{
                color: #595757;
            }
            .d-flex{
                margin-bottom: 10px;
                @media(min-width: 1024px){
                    flex-wrap: wrap;
                }
                .addBtn{
                    @media(max-width: 1023px){
                        display: none;
                    }
                    @media(min-width: 1024px){
                        height: 28px;
                        padding: 0 25px;
                        margin-left: 20px;
                    }
                }
            }
            .fee{
                flex: 1;
                font-size: 24px;
                font-weight: 500;
                height: 35px;
                line-height: 35px;
                @media(min-width: 1024px){
                    flex: 0 0 100%;
                    margin-bottom: 20px;
                }
            }
            /deep/.amount.mini{
                margin: 2px 0 0;
                width: inherit !important;
                &::before{
                    content: "數量";
                    font-size: 14px;
                    margin: 7px 5px 0 0;
                    color: var(--color-dark);
                    @media(min-width: 800px){
                        margin: 3px 5px 0 0;
                    }
                }
                .border-input{
                    border: solid #DCDFE6;
                    border-width: 1px 0;
                    background: #fff;
                    width: 50px;
                    height: 35px;
                    @media(min-width: 800px){
                        height: 28px;
                        width: 65px;
                    }
                    .el-input__inner{
                        height: 32px;
                        line-height: 32px;
                        @media(min-width: 800px){
                            height: 25px;
                            line-height: 25px;
                            padding: 0 0 0 10px;
                        }
                    }
                    &+.el-button{
                        border-radius: 0 4px 4px 0;
                    }
                }
                .el-button{
                    border: 1px solid #DCDFE6;
                    border-radius: 4px 0 0 4px;
                    height: 35px;
                    width: 40px;
                    line-height: 35px;
                    padding: 0;
                    &.el-button.disable{
                        opacity: 1;
                    }
                    @media(min-width: 800px){
                        width: 28px;
                        height: 28px;
                        line-height: 28px;
                        padding: 0;
                    }
                }

            }
        }
        .coupon-top .footer-button{
            padding-right: 20px;
            padding-left: 78px;
            @media(min-width: 1024px){
                display: none;
            }
            .el-button + .el-button {
                margin-left: 10px;
            }
        }
        .gift-pack-intro{
            //隨編輯器空格換行
            white-space: pre-line;
            margin-bottom: 20px;
        }
        //選擇日期場次
        .selectDate{
            background: var(--color-gray);
            height: 48px;
            border-radius: 10px;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content:space-between;
            padding: 0 20px;
            margin-bottom: 20px;
            @media(min-width: 1024px){
                display: none;
            }
        }
    }
    .addCart{
        //手機版不用購物車icon
        @media(max-width: 1023px){
            right: inherit;
            left: 20px;
            bottom: calc(10px + env(safe-area-inset-bottom));
        }
        @media(min-width: 1024px){
            display: none;
        }
    }
</style>
